import styled from "@emotion/styled";

export const StyledPageContainer = styled("main")(() => ({
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    margin: "0 !important",
    padding: "0 !important",
}));